<template>
  <div class="login-page">
    <app-navbar />
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-6 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h3 slot="header" class="header text-center">
                  Logging in...
                </h3>
              </card>
            </div>
          </div>
        </div>
        <app-footer />
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) " />
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from 'src/components/Layout/LoginAppNavbar';
import AppFooter from 'src/components/Layout/LoginAppFooter';
import Mgr from 'src/services/SecurityService';
import { mapState, mapActions, vuex } from 'vuex';

export default {
    components: {
        AppNavbar,
        AppFooter
    },
    data() {
        return {
            mgr: new Mgr()
        };
    },
    methods: {
        getRole() {
            this.$store.dispatch('getRole')
                .then(() => this.$router.push('/main'))
                .catch((error) => {
                    if (error.response.status === 400) {
                        this.$router.push('/expired-token');
                    } else if (error.response.data.message.startsWith('Cannot handle token prior to')) {
                        // catch the cannot handle token prior to error that causes the 500 error
                        this.$router.push('/sync-clock');
                    } else {
                        // If any other error (most likely 404), give them this helpful page instead
                        this.$router.push('/no-account');
                    }
                });
        },
        getUserLocations() {
            this.$store.dispatch('getUserLocations');
        }
    },
    mounted() {
        this.mgr.processLoginResponse()
            .then(() => {
                // Make call to get role
                this.getRole();
                this.getUserLocations();
            }).catch((error) => {
                // catch the iat in the future error
                if (error.toString().startsWith('Error: iat is in the future')
                      || error.toString().startsWith('Error: exp is in the past')) {
                    this.$router.push('/sync-clock');
                } else {
                    // If there's a javascript error we can try to re-route them to this helpful page
                    this.$router.push('/no-account');
                }
            });
    }
};
</script>
<style>
</style>
